import { MODALS } from './constants';
import { METHOD, PROVIDER } from '../../Payment/Payment.constants';
import { FormAddon, FormAdyen, FormPaycomet } from '../components';

const { CARD, PAYPAL, PCIPROXY, TPV } = METHOD;
const { ADDON, ADYEN, PAYCOMET } = PROVIDER;

export const getComponent = ({ cardValidation = false, method, methodConfig, provider } = {}) => {
  let component;
  const isValidPayment = [PAYPAL, TPV].includes(method) || ([CARD, PCIPROXY].includes(method) && cardValidation);

  if (methodConfig && isValidPayment) component = MODALS[methodConfig.modal];
  else if (provider === ADDON && isValidPayment) component = FormAddon;
  else if (provider === ADYEN && isValidPayment) component = FormAdyen;
  else if (provider === PAYCOMET && isValidPayment) component = FormPaycomet;

  return component;
};
